(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("classnames"), require("@swrve/icons"), require("react-router-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "classnames", "@swrve/icons", "react-router-dom"], factory);
	else if(typeof exports === 'object')
		exports["@swrve/core"] = factory(require("prop-types"), require("react"), require("classnames"), require("@swrve/icons"), require("react-router-dom"));
	else
		root["@swrve/core"] = factory(root["prop-types"], root["react"], root["classnames"], root["@swrve/icons"], root["react-router-dom"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__) {
return 